import { Button, Card, Space, Typography } from 'antd';
import { PlusOutlined, KeyOutlined } from '@ant-design/icons';
import { useGetApiKeysQuery, useRevokeApiKeyMutation } from '@app/services';
import { useState } from 'react';
import ApiKeyList from './ApiKeyList';
import CreateKeyModal from './CreateKeyModal';

const { Title, Text } = Typography;

interface Props {
    appName: string;
}

export default function ApiKeyManagement({ appName }: Props) {
    const [showCreate, setShowCreate] = useState(false);
    const { data: keys = [], isLoading } = useGetApiKeysQuery(appName);
    const [revokeKey, { isLoading: revoking }] = useRevokeApiKeyMutation();

    const handleRevoke = (keyId: string) => {
        revokeKey({ appName, keyId });
    };

    return (
        <Card>
            <Space direction="vertical" style={{ width: '100%' }} size="middle">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Space>
                        <KeyOutlined />
                        <Title level={5} style={{ margin: 0 }}>API Keys</Title>
                    </Space>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => setShowCreate(true)}
                    >
                        Create Key
                    </Button>
                </div>
                <Text type="secondary">
                    API keys authenticate requests to your REST API. Include the key in the <code>X-ModelPark-Key</code> header.
                </Text>
                <ApiKeyList
                    keys={keys}
                    loading={isLoading}
                    onRevoke={handleRevoke}
                    revoking={revoking}
                />
            </Space>
            <CreateKeyModal
                appName={appName}
                open={showCreate}
                onClose={() => setShowCreate(false)}
            />
        </Card>
    );
}
